import { useState } from "react";
import { Modal, Button, Form, Card } from "react-bootstrap";

const CONNECTION_TYPES = [
  {
    key: "default",
    label: "QR Code",
    badge: "PADRÃO",
    description:
      "Conecte seu número existente escaneando o QR Code diretamente pelo celular. Rápido, seguro e estável.",
    security: false,
  },
  {
    key: "security",
    label: "QR Code (Canal de segurança)",
    badge: "SEGURANÇA",
    description: "Conexão voltada para segurança dos seus grupos, contra invasores.",
    security: true,
  },
];

/**
 * Modal "Novo Canal" — replica UX do OrbitSender.
 */
export default function NewChannelModal({ show, onClose, onCreate, saving }) {
  const [name, setName] = useState("");
  const [selectedType, setSelectedType] = useState("default");

  function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim()) return;
    const type = CONNECTION_TYPES.find((t) => t.key === selectedType);
    onCreate({ name: name.trim(), security: type.security });
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>📱 Novo Canal</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <p className="text-muted">Conexão via QR Code · WhatsApp Web</p>

          <Form.Group>
            <Form.Label>Nome do Canal</Form.Label>
            <Form.Control
              type="text"
              placeholder="# meu-canal"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              minLength={2}
              maxLength={100}
            />
            <Form.Text className="text-muted">
              💡 Formatação automática: minúsculas e hífens
            </Form.Text>
          </Form.Group>

          <Form.Label className="mt-3">Tipo de Conexão</Form.Label>
          {CONNECTION_TYPES.map((type) => (
            <Card
              key={type.key}
              className={`mb-2 ${
                selectedType === type.key ? "border-primary" : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedType(type.key)}
            >
              <Card.Body className="d-flex align-items-center">
                <Form.Check
                  type="radio"
                  checked={selectedType === type.key}
                  onChange={() => setSelectedType(type.key)}
                />
                <div className="ml-3 flex-grow-1">
                  <strong>{type.label}</strong>{" "}
                  <span className="badge badge-secondary ml-1">
                    {type.badge}
                  </span>
                  <div className="small text-muted">{type.description}</div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" disabled={saving}>
            {saving ? "Criando..." : "+ Criar Canal"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
